import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { User, Users } from "lucide-react";
import { BeraterPanel } from "./BeraterPanel";
import { KundenPanel } from "./KundenPanel";
import type { BeratungSeite } from "@/hooks/useBeratungSeiten";

interface BeratungMobileLayoutProps {
  seite: BeratungSeite | null;
  formValues: Record<string, any>;
  onFieldChange: (fieldId: string, value: any) => void;
  isLoading?: boolean;
  interactiveTiles?: boolean;
  onTileSelect?: (tileId: string) => void;
  hoveredTileId?: string | null;
  onTileHover?: (tileId: string | null) => void;
}

export function BeratungMobileLayout({
  seite,
  formValues,
  onFieldChange,
  isLoading,
  interactiveTiles = false,
  onTileSelect,
  hoveredTileId,
  onTileHover,
}: BeratungMobileLayoutProps) {
  if (isLoading) {
    return (
      <div className="flex-1 flex items-center justify-center">
        <p className="text-muted-foreground">Lade Beratungsseiten...</p>
      </div>
    );
  }

  return (
    <Tabs defaultValue="berater" className="flex-1 flex flex-col min-h-0">
      <TabsList className="mx-4 mt-2 grid w-auto grid-cols-2">
        <TabsTrigger value="berater" className="flex items-center gap-2">
          <User className="h-4 w-4" />
          Berater
        </TabsTrigger>
        <TabsTrigger value="kunde" className="flex items-center gap-2">
          <Users className="h-4 w-4" />
          Kunde
        </TabsTrigger>
      </TabsList>
      
      <TabsContent value="berater" className="flex-1 min-h-0 mt-0 data-[state=active]:flex data-[state=active]:flex-col">
        <BeraterPanel
          seite={seite}
          formValues={formValues}
          onFieldChange={onFieldChange}
        />
      </TabsContent>
      
      <TabsContent value="kunde" className="flex-1 min-h-0 mt-0 data-[state=active]:flex data-[state=active]:flex-col">
        <KundenPanel
          seite={seite}
          formValues={formValues}
          onFieldChange={onFieldChange}
          interactiveTiles={interactiveTiles}
          onTileSelect={onTileSelect}
          hoveredTileId={hoveredTileId}
          onTileHover={onTileHover}
        />
      </TabsContent>
    </Tabs>
  );
}
